// import React, { useEffect, useState } from "react";
// import Cookies from "universal-cookie";
// import { FaEdit } from "react-icons/fa";
// import { MdCancel } from "react-icons/md";
// import "../../commoncss/Common.css";
// import { useToast } from "../../commoncomponents/ToastProvider";
// import Loader from "../../commoncomponents/Loader";

// const Agents = () => {
//   const [getAgent, setAgent] = useState({});
//   const [getFilter, setFilter] = useState({});
//   const [getAgentList, setAgentList] = useState([{}]);
//   const [getViewpopuplead, setViewpopuplead] = useState("");
//   const [loading, setLoading] = useState(false);
//   const cookie = new Cookies();
//   const { showToast } = useToast();

//   const create_agent = async () => {
//     setLoading(true);
//     try {
//       const resp = await fetch(`${process.env.REACT_APP_URL}/subadmin/newagent`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json; charset=UTF-8",
//         },
//         body: JSON.stringify({ token: cookie.get("subadmin"), ...getAgent }),
//       });
//       const dataset = await resp.json();
//       console.log(dataset);
//       if (resp.status === 200) {
//         if (dataset.status === true) {
//           showToast("Created agent successfully", "success");
//           search_agent();
//         } else {
//           showToast(dataset.err.msg || "Bad Authorization request", "error");
//         }
//       } else {
//         showToast("Failed to create agent, try again", "error");
//       }
//     } catch (error) {
//       console.log(error);
//       showToast("Request failed, network error", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const search_agent = async () => {
//     setLoading(true);
//     try {
//       const resp = await fetch(`${process.env.REACT_APP_URL}/subadmin/agent`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json; charset=UTF-8",
//         },
//         body: JSON.stringify({ token: cookie.get("subadmin"), ...getFilter }),
//       });
//       const dataset = await resp.json();
//       console.log(dataset);
//       if (resp.status === 200) {
//         if (dataset.status === true) {
//           setAgentList(dataset.data.data);
//         } else {
//           showToast(dataset.err.msg || "Failed to search agent", "error");
//         }
//       } else {
//         showToast("Failed to get agent list, try again", "error");
//       }
//     } catch (error) {
//       console.log(error);
//       showToast("Failed to get agent list or network error", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const modify_agent = async (updates, agent) => {
//     try {
//       setLoading(true);
//       const resp = await fetch(`${process.env.REACT_APP_URL}/subadmin/setagent`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json; charset=UTF-8",
//         },
//         body: JSON.stringify({
//           token: cookie.get("subadmin"),
//           updates: updates,
//           agent: agent,
//         }),
//       });
//       const dataset = await resp.json();
//       if (resp.status === 200) {
//         if (dataset.status === true) {
//           search_agent();
//           showToast("Updated successfully", "success");
//         } else {
//           showToast("Failed to update agent, try again", "error");
//         }
//       } else {
//         showToast(`Request failed, ${resp.status}, try later`, "error");
//       }
//     } catch (error) {
//       console.log("Failed to update agent", error);
//       showToast(
//         "Network or server errror, please try after some time",
//         "error"
//       );
//     }
//   };

//   const password_reset = async () => {
//     try {
//       setLoading(true);
//       const resp = await fetch(`${process.env.REACT_APP_URL}/subadmin/update`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json; charset=UTF-8",
//         },
//         body: JSON.stringify({
//           token: cookie.get("subadmin"),
//           agent_id: getViewpopuplead,
//           password: document.getElementById("newpassword").value,
//         }),
//       });
//       const dataset = await resp.json();
//       if (resp.status === 200) {
//         if (dataset.status === true) {
//           showToast("Password update successfully", "success");
//           setViewpopuplead("");
//         } else {
//           showToast("Failed to reset password, try again", "error");
//         }
//       } else {
//         showToast(`Request failed, ${resp.status}, try later`, "error");
//       }
//     } catch (error) {
//       console.log("Failed to reset password", error);
//       showToast(
//         "Network or server errror, please try after some time",
//         "error"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const PopupLead = () => {
//     if (getViewpopuplead !== "") {
//       return (
//         <>
//           <div
//             className="parentPopup"
//             onClick={(e) => {
//               setViewpopuplead("");
//             }}
//           ></div>
//           <div className="childPopup">
//             <div className="cancel_icon_container">
//               <MdCancel
//                 className="cancel_icon"
//                 onClick={() => setViewpopuplead("")}
//               />
//             </div>
//             <table>
//               <tr>
//                 <td>Name : </td>
//                 {getAgentList.map((e, index) => {
//                   console.log(e.id, getViewpopuplead);
//                   if (e.id == getViewpopuplead) {
//                     return <td>{e.name}</td>;
//                   }
//                 })}

//                 {/* <td>{getLead[0].name}</td> */}
//               </tr>
//               <tr>
//                 <td>Email : </td>
//                 {getAgentList.map((e, index) => {
//                   console.log(e.id, getViewpopuplead);
//                   if (e.id == getViewpopuplead) {
//                     return <td>{e.email}</td>;
//                   }
//                 })}
//                 {/* <td>{getLead[0].phone}</td> */}
//               </tr>
//               {/* <tr>
//                 <td>Amount</td>
//                 <td>
//                   <input
//                     id="updateamount"
//                     type="text"
//                     name="amount"
//                     placeholder="Enter Amount here"
//                   />
//                 </td>
//               </tr> */}
//               <tr>
//                 <td>New Password</td>
//                 <td>
//                   <input
//                     id="newpassword"
//                     type="text"
//                     name="password"
//                     placeholder="Enter New Password"
//                   />
//                 </td>
//               </tr>
//             </table>
//             <div
//               className="btn_container"
//               style={{
//                 width: "100%",
//                 display: "flex",
//                 justifyContent: "center",
//                 margin: "10px 0px",
//               }}
//             >
//               <button
//                 onClick={(ee) => {
//                   ee.preventDefault();
//                   password_reset();
//                 }}
//               >
//                 {loading ? <Loader loading={loading} /> : "Reset"}
//               </button>
//             </div>
//           </div>
//         </>
//       );
//     }
//   };

//   useEffect(() => {
//     search_agent();
//   }, []);

//   return (
//     <>
//       <div className="agent_wrapper">
//         <div className="top_search_fields">
//           <PopupLead />
//           <div className="fields_row">
//             <div className="fields_item">
//               <label>Name</label>
//               <input
//                 type="text"
//                 name="name"
//                 placeholder="Enter Name"
//                 onChange={(e) => {
//                   setAgent({
//                     ...getAgent,
//                     [e.target.name]: e.target.value,
//                   });
//                 }}
//               />
//             </div>
//             <div className="fields_item">
//               <label>Email</label>
//               <input
//                 type="text"
//                 name="email"
//                 placeholder="Enter Email"
//                 onChange={(e) => {
//                   setAgent({
//                     ...getAgent,
//                     [e.target.name]: e.target.value,
//                   });
//                 }}
//               />
//             </div>
//             <div className="fields_item">
//               <label>Password</label>
//               <input
//                 type="text"
//                 name="password"
//                 placeholder="Enter password"
//                 onChange={(e) => {
//                   setAgent({
//                     ...getAgent,
//                     [e.target.name]: e.target.value,
//                   });
//                 }}
//               />
//             </div>
//           </div>
//           <div className="btn_container">
//             <button
//               onClick={(e) => {
//                 e.preventDefault();
//                 create_agent();
//               }}
//             >
//               {loading ? <Loader loading={loading} /> : "Create Agent"}
//             </button>
//             {/* <button>Search Agent</button> */}
//           </div>
//         </div>
//         <div className="table_container">
//           <table>
//             <tr>
//               <th>Name</th>
//               <th>Email</th>
//               <th>Status</th>
//               <th>Edit</th>
//             </tr>
//             {getAgentList.map((e, index) => {
//               return (
//                 <tr>
//                   <td>{e.name}</td>
//                   <td>{e.email}</td>
//                   <td className="inputonoff">
//                     {e.status ? (
//                       <input
//                         name={e.id}
//                         type="checkbox"
//                         checked={e.status}
//                         onClick={(e) => {
//                           modify_agent({ status: false }, e.target.name);
//                         }}
//                       ></input>
//                     ) : (
//                       <input
//                         name={e.id}
//                         type="checkbox"
//                         checked={e.status}
//                         onClick={(e) => {
//                           modify_agent({ status: true }, e.target.name);
//                         }}
//                       ></input>
//                     )}
//                   </td>
//                   <td
//                     onClick={(f) => {
//                       setViewpopuplead(e.id);
//                     }}
//                     style={{ fontSize: "23px", color: "#4b49ac" }}
//                   >
//                     <FaEdit className="edit_icon" />
//                   </td>
//                 </tr>
//               );
//             })}
//           </table>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Agents;
import React, { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import { FaEdit } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import "../../commoncss/Common.css";
import { useToast } from "../../commoncomponents/ToastProvider";
import Loader from "../../commoncomponents/Loader";

const Agents = () => {
  const [getAgent, setAgent] = useState({});
  const [getFilter, setFilter] = useState({});
  const [getAgentList, setAgentList] = useState([{}]);
  const [getViewpopuplead, setViewpopuplead] = useState("");
  const [loading, setLoading] = useState(false);
  const cookie = new Cookies();
  const { showToast } = useToast();

  const create_agent = async () => {
    setLoading(true);
    try {
      const resp = await fetch(`${process.env.REACT_APP_URL}/subadmin/newagent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({ token: cookie.get("subadmin"), ...getAgent }),
      });
      const dataset = await resp.json();
      console.log(dataset);
      if (resp.status === 200) {
        if (dataset.status === true) {
          showToast("Created agent successfully", "success");
          search_agent();
        } else {
          showToast(dataset.err.msg || "Bad Authorization request", "error");
        }
      } else {
        showToast("Failed to create agent, try again", "error");
      }
    } catch (error) {
      console.log(error);
      showToast("Request failed, network error", "error");
    } finally {
      setLoading(false);
    }
  };

  const search_agent = async () => {
    setLoading(true);
    try {
      const resp = await fetch(`${process.env.REACT_APP_URL}/subadmin/agent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({ token: cookie.get("subadmin"), ...getFilter }),
      });
      const dataset = await resp.json();
      console.log(dataset);
      if (resp.status === 200) {
        if (dataset.status === true) {
          setAgentList(dataset.data.data);
        } else {
          showToast(dataset.err.msg || "Failed to search agent", "error");
        }
      } else {
        showToast("Failed to get agent list, try again", "error");
      }
    } catch (error) {
      console.log(error);
      showToast("Failed to get agent list or network error", "error");
    } finally {
      setLoading(false);
    }
  };

  const modify_agent = async (updates, agentId) => {
    try {
      setLoading(true);
      const resp = await fetch(`${process.env.REACT_APP_URL}/subadmin/setagent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          token: cookie.get("subadmin"),
          updates: updates,
          agent: agentId,
        }),
      });
      const dataset = await resp.json();
      if (resp.status === 200) {
        if (dataset.status === true) {
          setViewpopuplead("");
          showToast("Updated successfully", "success");
          search_agent(); // Refresh the list after successful update
        } else {
          showToast("Failed to update agent, try again", "error");
        }
      } else {
        showToast(`Request failed, ${resp.status}, try later`, "error");
      }
    } catch (error) {
      console.log("Failed to update agent", error);
      showToast(
        "Network or server errror, please try after some time",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const password_reset = async () => {
    try {
      setLoading(true);
      const resp = await fetch(`${process.env.REACT_APP_URL}/subadmin/update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          token: cookie.get("subadmin"),
          agent_id: getViewpopuplead,
          password: document.getElementById("newpassword").value,
        }),
      });
      const dataset = await resp.json();
      if (resp.status === 200) {
        if (dataset.status === true) {
          showToast("Password update successfully", "success");
          setViewpopuplead("");
        } else {
          showToast("Failed to reset password, try again", "error");
        }
      } else {
        showToast(`Request failed, ${resp.status}, try later`, "error");
      }
    } catch (error) {
      console.log("Failed to reset password", error);
      showToast(
        "Network or server errror, please try after some time",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const PopupLead = () => {
    if (getViewpopuplead !== "") {
      return (
        <>
          <div
            className="parentPopup"
            onClick={(e) => {
              setViewpopuplead("");
            }}
          ></div>
          <div className="childPopup">
            <div className="cancel_icon_container">
              <MdCancel
                className="cancel_icon"
                onClick={() => setViewpopuplead("")}
              />
            </div>
            <table>
              <tbody>
                <tr>
                  <td>Name : </td>
                  {getAgentList.map((e, index) => {
                    console.log(e.id, getViewpopuplead);
                    if (e.id == getViewpopuplead) {
                      return <input id="name" name="name" defaultValue={e.name}></input>
                      // return <td key={index}>{e.name}</td>;
                    }
                  })}
                </tr>
                <tr>
                  <td>Email : </td>
                  {getAgentList.map((e, index) => {
                    console.log(e.id, getViewpopuplead);
                    if (e.id == getViewpopuplead) {
                      return <input id="email" name="email" defaultValue={e.email} ></input>;
                      // return <td key={index}>{e.email}</td>;
                    }
                  })}
                </tr>
                <tr>
                  <td>New Password</td>
                  <td>
                    <input
                      id="newpassword"
                      type="text"
                      name="password"
                      placeholder="Enter New Password"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              className="btn_container"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                margin: "10px 0px",
              }}
            >
              <button
                onClick={(ee) => {
                  ee.preventDefault();
                  modify_agent({ name: document.getElementById("name").value, email: document.getElementById("email").value }, getViewpopuplead);
                }}
              >
                {loading ? <Loader loading={loading} /> : "Save"}
              </button>
              <button
                onClick={(ee) => {
                  ee.preventDefault();
                  password_reset();
                }}
              >
                {loading ? <Loader loading={loading} /> : "Reset"}
              </button>
            </div>
          </div>
        </>
      );
    }
  };

  useEffect(() => {
    search_agent();
  }, []);

  return (
    <>
      <PopupLead />
      <div className="agent_wrapper">
        <div className="top_search_fields">
          <div className="fields_row">
            <div className="fields_item">
              <label>Name</label>
              <input
                type="text"
                name="name"
                placeholder="Enter Name"
                onChange={(e) => {
                  setAgent({
                    ...getAgent,
                    [e.target.name]: e.target.value,
                  });
                }}
              />
            </div>
            <div className="fields_item">
              <label>Email</label>
              <input
                type="text"
                name="email"
                placeholder="Enter Email"
                onChange={(e) => {
                  setAgent({
                    ...getAgent,
                    [e.target.name]: e.target.value,
                  });
                }}
              />
            </div>
            <div className="fields_item">
              <label>Password</label>
              <input
                type="text"
                name="password"
                placeholder="Enter password"
                onChange={(e) => {
                  setAgent({
                    ...getAgent,
                    [e.target.name]: e.target.value,
                  });
                }}
              />
            </div>
          </div>
          <div className="btn_container">
            <button
              onClick={(e) => {
                e.preventDefault();
                create_agent();
              }}
            >
              {loading ? <Loader loading={loading} /> : "Create Agent"}
            </button>
          </div>
        </div>
        <div className="table_container">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Status</th>
                <th>Edit</th>
              </tr>
            </thead>
            <tbody>
              {getAgentList.map((agent, index) => {
                return (
                  <tr key={agent.id || index}>
                    <td>{agent.name}</td>
                    <td>{agent.email}</td>
                    <td className="inputonoff">
                      <input
                        type="checkbox"
                        checked={agent.status || false}
                        onChange={(event) => {
                          // Use the current agent status to determine new status
                          const newStatus = !agent.status;
                          modify_agent({ status: newStatus }, agent.id);
                        }}
                        disabled={loading}
                      />
                    </td>
                    <td
                      onClick={() => {
                        setViewpopuplead(agent.id);
                      }}
                      style={{ fontSize: "23px", color: "#4b49ac", cursor: "pointer" }}
                    >
                      <FaEdit className="edit_icon" />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Agents;